<template>
  <div class="bindPhone" >
    <div class="mainInfo">
      <div class="info-item">
        <van-cell-group>
          <!-- 职业 -->
          <van-cell title="职业" is-link @click="showProPicker = true">
            <template #title>
              <span class="custom-title">职业</span>
            </template>
            <template #default>
              <span class="custom-placeholder" v-if="!form.profession">请选择职业</span>
              <span class="custom-value" v-else>{{ form.profession }}</span>
            </template>
          </van-cell>
          <van-popup v-model="showProPicker" position="bottom">
            <van-picker
              show-toolbar
              :columns="jobList"
              @confirm="confirmPro"
              @cancel="showProPicker = false"
            />
          </van-popup>
          <!-- 性别 -->
          <van-cell title="性别" is-link @click="showSexPicker = true">
            <template #title>
              <span class="custom-title">性别</span>
            </template>
            <template #default>
              <span class="custom-placeholder" v-if="!form.sexStr">请选择性别</span>
              <span class="custom-value" v-else>{{ form.sexStr }}</span>
            </template>
          </van-cell>
          <van-popup v-model="showSexPicker" position="bottom">
            <van-picker
              show-toolbar
              value-key="key"
              :columns="sexList"
              @confirm="confirmSex"
              @cancel="showSexPicker = false"
            />
          </van-popup>
        </van-cell-group>
      </div>
      <div class="info-item">
        <van-cell-group>
          <!-- 联系电话 -->
          <!-- <van-field v-model="form.phone" disabled type="tel" input-align="right" maxlength="11" placeholder="请输入联系电话">
            <template #label>
              <span class="custom-title">联系电话</span>
            </template>
          </van-field> -->
          <van-cell title="联系电话">
            <template #title>
              <span class="custom-title">联系电话</span>
            </template>
            <template #default>
              <span class="custom-placeholder">{{form.phone}}</span>
            </template>
          </van-cell>
          <!-- 现居地址 -->
          <van-field v-model="form.address" input-align="right" class="custom-field" maxlength="50" label="现居地址" placeholder="请输入现居地址">
            <template #label>
              <span class="custom-title">现居地址</span>
            </template>
          </van-field>
        </van-cell-group>
      </div>
      <div class="info-item">
        <van-cell-group>
          <!-- 出生日期 -->
          <van-cell title="出生日期" is-link @click="showBirPicker = true">
            <template #title>
              <span class="custom-title">出生日期</span>
            </template>
            <template #default>
              <span class="custom-placeholder" v-if="!form.birthdayStr">请选择出生日期</span>
              <span class="custom-value" v-else>{{ form.birthdayStr }}</span>
            </template>
          </van-cell>
          <van-popup v-model="showBirPicker" position="bottom">
            <van-datetime-picker
              type="date"
              v-model="time"
              :min-date="minDate"
              :max-date="maxDate"
              @confirm="confirmBir"
              @cancel="showBirPicker = false"
            />
          </van-popup>
          <!-- 文化程度 -->
          <van-cell title="文化程度" is-link @click="showDipPicker = true">
            <template #title>
              <span class="custom-title">文化程度</span>
            </template>
            <template #default>
              <span class="custom-placeholder" v-if="!form.diploma">请选择文化程度</span>
              <span class="custom-value" v-else>{{ form.diploma }}</span>
            </template>
          </van-cell>
          <van-popup v-model="showDipPicker" position="bottom">
            <van-picker
              show-toolbar
              :columns="diplomaList"
              @confirm="confirmDip"
              @cancel="showDipPicker = false"
            />
          </van-popup>
        </van-cell-group>
      </div>
      <div class="submitButton">
        <div class="custom-button" @click="onSubmit">
          提交
        </div>
      </div>
      <div class="caution">中国农业科学院农业信息研究所</div>
    </div>
  </div>
</template>

<script>
import { getType } from '../../api/common'
import { updateUser } from '../../api/user'
import { diplomaList, sexList } from '../../config/index'
import { formatTime } from '../../util/index'
import store from '../../store/index'
export default {
  created() {
    this.getTypeList()
    const userInfo = store.getters.userInfo
    if (userInfo) {
      this.$set(this.form, 'sex', userInfo.user.sex)
      if (Number(userInfo.user.sex) === 1) {
        this.$set(this.form, 'sexStr', '男')
      }else if (Number(userInfo.user.sex) === 2) {
        this.$set(this.form, 'sexStr', '女')
      }
      this.$set(this.form, 'id', userInfo.user.id || '')
      this.$set(this.form, 'diploma', userInfo.user.diploma || '')
      this.$set(this.form, 'phone', userInfo.user.phone || '')
      this.$set(this.form, 'address', userInfo.user.address || '')
      this.$set(this.form, 'profession', userInfo.user.profession || '')
      this.$set(this.form, 'birthdayStr', userInfo.user.birthdayStr || '')
    }
  },
  data() {
    return {
      isRequest: false,
      diplomaList, // 文化程度列表
      sexList, // 性别列表
      showProPicker: false, // 职业选择弹窗
      showDipPicker: false, // 文化程度选择弹窗
      showBirPicker: false, // 出生日期选择弹窗
      showSexPicker: false, // 性别选择弹窗
      minDate: new Date(1900, 0, 1),
      maxDate: new Date(),
      time: new Date(),
      jobList: [],
      form: {
        sex: '', // 性别
        sexStr: '',
        phone: '', // 联系电话
        id: '',
        profession: '', //职业
        address: '', // 地址
        birthdayStr: '', //生日
        diploma: '' // 文化程度
      }
    }
  },
  methods: {
    // 获取职业
    getTypeList() {
      getType({ type: 1 }).then(res => {
        const list1 = []
        res.data.forEach(item => {
          list1.push(item.name)
        })
        this.jobList = list1
      })
    },
    confirmDip(value) {
      // 文化程度弹窗确认
      this.$set(this.form, 'diploma', value)
      this.showDipPicker = false
    },
    confirmPro(value) {
      // 职业弹窗确认
      this.$set(this.form, 'profession', value)
      this.showProPicker = false
    },
    confirmSex(item) {
      // 性别弹窗确认
      this.$set(this.form, 'sex', item.value)
      this.$set(this.form, 'sexStr', item.key)
      this.showSexPicker = false
    },
    confirmBir(value) {
      this.$set(this.form, 'birthdayStr', this.formateTime(value))
      this.showBirPicker = false
    },
    tips(msg) {
      this.$notify({
        message: msg,
        duration: 1500,
      })
    },
    onSubmit() {
      if (this.isRequest) {
        return
      }
      if(!this.form.profession) {
        this.tips('请选择职业')
        return
      }
      if(!this.form.sexStr) {
        this.tips('请选择性别')
        return
      }
      if(!this.form.birthdayStr) {
        this.tips('请选择出生日期')
        return
      }
      if(!this.form.diploma) {
        this.tips('请选择文化程度')
        return
      }
      if(!this.form.address) {
        this.tips('请输入现居地址')
        return
      }
      
      this.$dialog.confirm({
        title: '提示',
        message: '确定保存并提交吗?'
      }).then( () => {
        this.isRequest = true
        updateUser(this.form).then(res => {
          if (res.error) {
            return
          }
          this.$dialog.confirm({
            message: '保存成功',
            showCancelButton: false,
          }).then( () => {
            this.$router.go(-1)
          })
        }).finally( () => {
          this.isRequest = false
        })
      })
    },
    onError(error) {
      console.log(error)
    },
    formateTime(val) {
      const fmt = formatTime(val)
      return `${fmt.year}-${fmt.month}-${fmt.day}` 
    }
  },

}
</script>

<style lang="stylus">
.bindPhone {
  background: #F2F2F2;
  min-height: 100vh;
  .mainInfo {
    padding-bottom: 40px
    .info-item {
      margin-bottom: 20px;
      .custom-placeholder {   
        color: #888888;
        font-size: 26px;
        font-weight: 400;
      }
      .custom-value {   
        color: #333333;
        font-size: 26px;
        font-weight: 500;
      }
      .custom-icon{
        width: 20px;
        height: 20px;
      }
      .custom-field {
        input {
          color: #333333;
          font-size: 26px !important;
          font-weight: 500;
        }
      }
      .custom-title {
        font-size: 30px;
        font-weight: 500;
        color: #101010;
      }
    }
    .submitButton {
      margin-top: 150px;
      display: flex;
      justify-content: center
      .custom-button {
        width: 500px;
        font-size: 28px;
        height: 90px;
        color: #fff;
        // line-height: 90px;
        // text-align: center
        background: #368BFF;
        border-radius: 45px;
        display: flex;
        justify-content: center;
        align-items: center
      }
    }
    .caution {
      margin-top: 50px;
      // width: 100%;
      width: 100%;
      text-align: center;
      font-size: 24px;
      font-weight: 400;
      color: #999999;
    }
  }
}
</style>